<template>
    <div>
        <el-dialog title="新建用户"  v-model="dialogFormVisible">
            <el-form ref="formUser" :model="formUser" :rules="formUserRules">
                <el-form-item label="用户名" prop="user_account" :label-width="formLabelWidth">
                    <el-input v-model="formUser.user_account"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="user_password" :label-width="formLabelWidth">
                    <el-input v-model="formUser.user_password"></el-input>
                </el-form-item>
                <el-form-item label="中文名" prop="user_cnname" :label-width="formLabelWidth">
                    <el-input v-model="formUser.user_cnname"></el-input>
                </el-form-item>
                <el-form-item label="英文名" prop="user_enname" :label-width="formLabelWidth">
                    <el-input v-model="formUser.user_enname"></el-input>
                </el-form-item>
                <el-form-item label="用户角色" prop="user_role" :label-width="formLabelWidth">
                    <el-select v-model="formUser.user_role" placeholder="请选择">
                    <el-option label="管理员" value="99"></el-option>
                    <el-option label="录入员" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" :label-width="formLabelWidth">
                    <el-radio-group v-model="formUser.user_status">
                        <el-radio :label="0">启用</el-radio>
                        <el-radio :label="1">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="closedDialog">取 消</el-button>
                <el-button type="primary" @click="submitForm()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/api/api'
    export default {
        name: "addUserDialog",
        components: {  },
        data() {
            return {
                dialogFormVisible:false,
                formLabelWidth:100,
                formUser: {
                    user_account:"",
                    user_password:"",
                    user_cnname:"",
                    user_enname:"",
                    user_role:"",
                    user_status:0,
                },
                formUserRules:{
                    user_account: [
                        { required: true, message: 'Please input account name', trigger: 'blur' },
                    ],
                    user_password: [
                        { required: true, message: 'Please input password', trigger: 'blur' },
                    ],
                    user_cnname: [
                        { required: true, message: 'Please input cnname', trigger: 'blur' },
                    ],
                    user_enname: [
                        { required: true, message: 'Please input enname', trigger: 'blur' },
                    ],
                    user_role: [
                        { required: true, message: 'Please select role', trigger: 'chanage' },
                    ]
                }
            }
        },
        props:{
            isAddUserShow:Boolean,
            timekey:Number
        },
        created(){
        },
        methods:{
            closedDialog(){
                this.dialogFormVisible = false;
                this.$refs['formUser'].resetFields();
                this.$emit('isAddUserShow', false);
            },
            submitForm(){
                this.$refs['formUser'].validate(( valid ) => {
                    if (valid) {
                        api.postAddUser( this.formUser ).then( res => {
                            if ( res.data.success) {
                                this.$message({
                                    message: '用户录入成功！',
                                    type: 'success'
                                });
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'warning'
                                });
                            }
                            this.dialogFormVisible = false;
                            this.$emit('getUserList');
                        }).catch( () => {
                            this.$message({
                                message: '用户录入出错，请联系相关员！',
                                type: 'errow'
                            });
                        });
                    } else {
                        return false;
                    }
                });
            }
        },
        watch:{
            isAddUserShow( newv ){
                this.dialogFormVisible = newv;
            },
            timekey( newv, oldv ){
                if (newv !== oldv && oldv !== "")
                this.dialogFormVisible = this.$props.isAddUserShow;
            }
        }
    }
</script>


<style scoped>
</style>